import { render, staticRenderFns } from "./CampaignTemplateDetail.vue?vue&type=template&id=f110b54a&"
import script from "./CampaignTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./CampaignTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports